// extracted by css-extract-rspack-plugin
export default {"list":"list-f2_PAW","loading":"loading-vTFGr1"};